<template>
  <div v-show="isShow" :style="domStyle" class="ivu-card-div">
    <!-- 请在此添加代码 -->

    <template>
      <Card :bordered="cardBorder" :shadow="cardShadow">
        <p slot="title" :style="cardStyle">
          {{ textName }}
        </p>
        <ul>
          <li v-for="item in dataValue">
            <a :style="cardStyle">{{ item.name }}</a>
            <span
              :style="{
                color: item.color,
                fontSize: cardStyle.fontSize,
                fontFamily: cardStyle.fontFamily
              }"
            >
              {{ item.value }}
            </span>
          </li>
        </ul>
      </Card>
    </template>
    <Icon
      type="ios-settings"
      size="20"
      class="setting"
      @click="modal1 = true"
    />
    <Modal v-model="modal1" :z-index="2000">
      <div>
        <Row>
          <Col span="15">
            <Form :model="formItem" :label-width="80">
              <FormItem :label="addCard.cardName">
                <Input
                  v-model="formItem.cardName"
                  :placeholder="addCard.name"
                />
              </FormItem>
              <FormItem :label="addCard.cardTag">
                <Row>
                  <Col span="16">
                    <Input
                      v-model="formItem.cardTag"
                      :placeholder="addCard.tag"
                    />
                  </Col>
                  <Col span="4" offset="1">
                    <Button @click="addPoint">{{ addCard.getTag }}</Button>
                  </Col>
                </Row>
              </FormItem>

              <FormItem :label="addCard.color">
                <Row>
                  <Col span="4">
                    <ColorPicker v-model="formItem.cardColor" recommend />
                  </Col>
                </Row>
              </FormItem>
            </Form>
          </Col>
        </Row>
      </div>
      <div slot="footer">
        <Button type="text" size="large" @click="cancel">取消</Button>
        <Button type="primary" size="large" @click="ok">确定</Button>
      </div>
    </Modal>
    <div v-if="isEnable" :style="enableStyle"></div>
  </div>
</template>
<script>
import $ from "jquery";
import Print from "print-js";
import { resolve } from "url";
export default {
  name: "",
  props: ["primitives", "fvSystemApi", "parentObject"],
  created: function() {
    //组件数据混淆
    this.mixin(this.primitives);
    //组件大小位置初始化
    this.domStyle = {
      position: "absolute",
      left: this.x + "px",
      top: this.y + "px",
      width: this.width + "px",
      height: this.height + "px",
      border: "1px solid #dcdee2",
      borderColor: "#e8eaec",
      borderRadius: "4PX"
    };
    this.enableStyle = {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0px",
      backgroundColor: "#ccbfbf",
      opacity: "0.5"
    };
    this.cardStyle = {
      fontSize: this.cardFont + "px",
      color: this.fontColor,
      fontFamily: this.fontName
    };
    this.modelsPath = this.parentObject.modelsPath.slice(0);
    this.modelsPath.push(this.registerName);
    this.$store.registerModule(this.modelsPath, {
      state: {
        $: this
      }
    });
  },
  data: function() {
    return {
      defaultNo: 1,
      defaultName: "内容",
      //是否可用
      isEnable: false,
      //是否显示
      isShow: true,
      setupTow: false,
      setup: false,
      //组件大小位置,在created(创建完毕，挂载前)函数中初始化
      domStyle: {},
      addCard: {},
      cardStyle: {},
      modal1: false,
      //弹窗显示隐藏
      modalCard: false,
      dataValue: [],
      //弹窗列表form表单
      formItem: {
        cardName: "",
        cardTag: "",
        cardColor: "#19be6b"
      },
      viewVersion:"10.0.3.3"
    };
  },
  mounted() {
    this.addCardlist = {
      title: "添加卡片内容",
      del: "删除",
      cardName: "内容",
      cardTag: "点",
      getTag: "获取点",
      color: "颜色",
      ok: "确定",
      close: "取消",
      tag: "点",
      name: "内容"
    };
    this.addCard = JSON.parse(JSON.stringify(this.addCardlist));
  },
  methods: {
    //弹窗确定按钮
    ok() {
      if (this.formItem.cardTag != "" && this.formItem.cardName != "") {
        let addObj = {
          color: this.formItem.cardColor,
          name: this.formItem.cardName,
          tagName: this.formItem.cardTag
        };
        this.data.push(addObj);
        this.getData();
        this.modal1 = false;
        this.formItem.cardTag = "";
        this.formItem.cardName = "";
      } else {
        if (this.formItem.cardTag == "") {
          alert("未选择点！");
        } else if (this.formItem.cardName == "") {
          alert("没有输入内容!");
        }
      }
    },
    //弹窗关闭按钮
    cancel() {
      this.modal1 = false;
    },
    /*
          参数：无
          作用：获取点列表从而对表单数据进行添加
      */
    addPoint() {
      if (window.isApp()) {
        this.showDataDialog().then(
          function(req) {
            if (req) {
              this.formItem.cardTag = req.name;
              if (this.formItem.isCurveName) {
                this.formItem.cardName = req.desc;
              }
            }
          }.bind(this)
        );
      } else {
        this.showTagSelectDialog().then(
          function(req) {
            if (req) {
              this.formItem.cardTag = req.name;
              if (this.formItem.isCurveName) {
                this.formItem.cardName = req.desc;
              }
            }
          }.bind(this)
        );
      }
    },
    async showDataDialog() {
      var tagName;
      await this.fvSystemApi.selectDataShow().then(function(name) {
        tagName = name;
      });
      return tagName;
    },
    /*
          参数：无
          作用：获取点列表数据
      */
    async showTagSelectDialog() {
      var tagName;
      await this.fvSystemApi
        .selectTagsShow("Test.测试1.tag1.PV", true, true, true)
        .then(function(name) {
          tagName = name;
        });
      return tagName;
    },

    /*
          参数：src 原json数据
          作用：混淆数据到当前对象
      */
    mixin(src) {
      for (var key in src) {
        this[key] = src[key];
      }
    },
    //添加点
    AddData(dataName, dataDesc) {
      if (dataDesc == undefined || dataDesc == null || dataDesc == "") {
        dataDesc = this.defaultName + this.defaultNo;
        this.defaultNo++;
        if (this.defaultNo > 1000) {
          this.defaultNo = 0;
        }
      }
        for (var j = 0; j < this.data.length; j++) {
          
          if (dataName == this.data[j].tagName) {
           alert("此点已经添加过内容，请重新添加！");
            return;
          }
        }
          let addObj = {
            color: "rgb(0,0,0)",
            name: dataDesc,
            tagName: dataName
          };
          this.data.push(addObj);
          this.getData();
    },
    //添加点以及同时设置点颜色
    AddDataEx: function(dataName, dataDesc, colorNumber) {
      for (var j = 0; j < this.data.length; j++) {
          
          if (dataName == this.data[j].tagName) {
           alert("此点已经添加过内容，请重新添加！");
            return;
          }
        }
      let iscolor = "#000";
      if (colorNumber != undefined) {
        var colorArr = window.FColorToRGB.getColors();
        var colorRgb = colorArr[colorNumber];
        colorRgb =
          "rgb(" + colorRgb[0] + "," + colorRgb[1] + "," + colorRgb[2] + ")";
        iscolor = colorRgb;
      } else {
        iscolor = "#000";
      }
      let addObj = {
        color: iscolor,
        name: dataDesc,
        tagName: dataName
      };
      this.data.push(addObj);
      this.getData();
    },
    ClearData() {
      this.data = [];
      this.dataValue = [];
      return;
    },
    /**
     * 作用： 脚本函数删除点
     * 参数： deleteName 删除点名称：测试.测试1.pv
     */

    DelData: function(deleteName) {
      if (deleteName == "") {
        return;
      }
      let flag = false;
    //   let data = this.data;
      for (var i = 0; i < this.data.length; i++) {
        if (deleteName == this.data[i].tagName && this.data.length > 0) {
          this.data.splice(i, 1);
          flag = true;
        }
      }
      for (const key in this.dataValue) {
        let element = this.dataValue[key];
        if(element.tagName == deleteName){
            this.dataValue.splice(key, 1);
        };
          
      }
      if(!flag){
          alert("要删除的点不存在");
      }else{
          this.getData();
      }
    },
    /*
          参数：e 鼠标信息
               domScale 窗口放大、缩小、偏移等信息
          作用：鼠标事件调用函数，无必要可不进行任何处理
      */
    doFixedEvent(e, domScale) {},
    /*
          参数：无
          作用：系统周期调用
      */
    onTimer() {
      if (this.isEnable) return;
      this.getData();
    },
    /*
          参数：无
          作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
      */
    onClose() {
      return new Promise(resolve => {
        resolve();
      });
    },
    //获取点数据
    getData() {
      for (var i = 0; i < this.data.length; i++) {
        var realData = this.fvSystemApi.getReal(this.data[i].tagName);
        this.data[i]["value"] = realData == undefined ? -9999 : realData.PV;
      }
      for (const key in this.data) {
        this.$set(this.dataValue, key, this.data[key]);
      }
    },

    /*
          参数：scaleObj 重绘信息
          作用：组件需要重绘时触发
      */
    reDraw(scaleObj) {
      this.cardStyle.fontSize =
        parseInt(this.cardFont * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) +
        "px";
      this.$el.style.fontSize =
        parseInt(12 * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px";
      this.domStyle.left =
        parseInt(this.x * (scaleObj.sx + scaleObj.zoom) + scaleObj.ox) + "px";
      this.domStyle.top =
        parseInt(this.y * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px";
      this.domStyle.width =
        parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
      this.domStyle.height =
        parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
      let ivuBodyHeight =
        parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) - 52 + "px";
      //设置背景颜色
      this.$el.firstChild.firstChild.style.background = this.cardBgcolor;
      this.$el.firstChild.lastChild.style.background = this.cardBgcolor
      this.$el.firstChild.style.background = this.cardBgcolor;
    },
    /*
          参数：isShow 显示隐藏
          作用：设置组件整体显隐
      */
    Show: function(isShow) {
      this.isShow = isShow ? true : false;
    },
    /*
          参数：isEnable 是否可用
          作用：设置组件是否可用
      */
    Enable: function(isEnable) {
      this.isEnable = isEnable ? false : true;
      //重新设置遮罩层的颜色
      this.enableStyle.width = this.$el.style.width;
      this.enableStyle.height = parseFloat(this.$el.firstChild.firstChild.clientHeight) + parseFloat(this.$el.firstChild.lastChild.clientHeight)+"px";
      if(this.isEnable){
        this.$el.style.overflow = "hidden";
      }else{
        this.$el.style.overflow = "auto";
      }
    }
  }
};
</script>
<style>
.ivu-example-case {
  padding: 0;
  height: 100%;
}

.ivu-card-bordered {
  border: 1px solid #dcdee2;
  border-color: #e8eaec;
}

.ivu-card {
  display: block;
  background: #fff;
  border-radius: 4px;
  font-size: 14px;
  position: relative;
  transition: all 0.2s ease-in-out;
  width: 100%;
  height: 100%;
}

.ivu-card-head {
  border-bottom: 1px solid #e8eaec;
  padding: 14px 10px;
  line-height: 1;
}

.ivu-card-extra {
  position: absolute;
  right: 16px;
  top: 14px;
}

.ivu-card-body {
  padding: 8px;
}

.ivu-card p {
  margin: 0;
}

.ivu-card-head-inner,
.ivu-card-head p {
  display: inline-block;
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #17233d;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.setting {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

/* ul{
      padding-left: 40px;
      list-style-type: disc;
  } */

.ivu-card ul {
  padding: 0 !important;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.ivu-card ul li {
  list-style: none;
  margin-bottom: 5px;
  font-size: 14px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.ivu-card ul li a {
  color: #2d8cf0;
  background: 0 0;
  text-decoration: none;
  outline: 0;
  cursor: pointer;
  transition: color 0.2s ease;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ivu-card ul li span {
  color: #ffac2d;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

*,
:after,
:before {
  box-sizing: border-box;
}

.ivu-card-shadow {
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
}
.ivu-card-div {
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 0;
  overflow: auto;
}

.ivu-card-div::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.ivu-card-div::-webkit-scrollbar {
  height: 6px;
  width: 6px;
  background-color: #f5f5f5;
}

.ivu-card-div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, rgb(122, 153, 217)),
    color-stop(0.72, rgb(73, 125, 189)),
    color-stop(0.86, rgb(28, 58, 148))
  );
}
</style>



// WEBPACK FOOTER //
// src/components/primitives/fvCard/fvCard.vue